<template>
  <div :class="classes">
       <pt-page-title title="政策规则详情"></pt-page-title>
       <pt-sub-title title="政策规则信息"></pt-sub-title>
       <table :class="$style['pt-policy-detail-table']">
           <pt-message-table-item label="政策名称">
               {{policy_detail.name}}
           </pt-message-table-item>
           <pt-message-table-item label="类型">
               {{typeName}}
           </pt-message-table-item>
           <pt-message-table-item label="创建时间">
               {{policy_detail.created_date}}
           </pt-message-table-item>
            <pt-message-table-item label="内容">
                <div v-if="isHtmlOfContent" v-html="policy_detail.content" :class="$style['pt-policy-detail-content']" class="pt-policy-detail-content-backgroud"></div>
                <div v-else :class="$style['pt-policy-detail-content']">{{policy_detail.content}}</div>
           </pt-message-table-item>
       </table>
       <div class="button-div">
           <el-button type="primary" @click="editPolicy">修改</el-button>
       </div>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-policy-detail'

export default {
  name: 'pt-policy-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    // 返回的政策内容是否是html
    isHtmlOfContent () {
      return this.type === 'afterSales' || this.type === 'privacy'
    }
  },
  props: {
    policyDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    type: {
      type: String,
      default: ''
    },
    typeName: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      policy_detail: this.policyDetail
    }
  },
  watch: {
    policyDetail: {
      handler: function (val) {
        this.policy_detail = val
      }
    }
  },
  methods: {
    editPolicy () {
      this.$router.push('/policy-form/' + this.type + '/' + 'true/' + this.id)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

.pt-policy-detail-content{
    white-space: pre-wrap!important;
    padding: 0 10px;
    display: block!important;
    ul,li{
        list-style-type:initial!important;
    }
    p,ul,ol{
        margin: inherit;
        line-height: inherit;
        margin-block-start:inherit;
        margin-block-end:inherit;
        white-space: normal;
    }

}
.pt-policy-detail-table{
    padding: 0 20px;
    overflow-x: hidden;
    display: block;
    tr{
        overflow-x: hidden;
        display: flex;
        td{
            // overflow-x:hidden
            &:first-child{
                flex: 0 0 5em;
            }
            &:last-child{
                overflow-x: hidden;
                display: -webkit-box;
            }
        }
    }
}
</style>
<style lang="less">
.pt-policy-detail{
    overflow-x:hidden
}
.pt-policy-detail-content-backgroud{

    background-color: #F9F9F9;
}
</style>
